import { Link } from 'react-router-dom';


export default function Privacy() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold bg-gradient-to-r from-amber-600 to-orange-500 bg-clip-text text-transparent">
            RecoverRefunds
          </Link>
          <Link to="/signup" className="text-sm text-amber-600 hover:text-amber-700 font-medium">
            Sign Up
          </Link>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-12">

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Privacy Policy</h1>
          <p className="text-slate-500 mb-8">Last updated: January 2, 2026</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 mb-4">
              RecoverRefunds collects information you provide directly, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Account information (name, email, company name)</li>
              <li>Store connection credentials for delivery platforms</li>
              <li>Order and transaction data imported from your connected accounts</li>
              <li>Dispute documentation and evidence you upload</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Provide and maintain our fraud detection and dispute services</li>
              <li>Analyze order patterns to identify potential fraudulent refund requests</li>
              <li>Generate dispute letters and supporting documentation</li>
              <li>Track recovery outcomes and provide analytics</li>
              <li>Communicate with you about your account and our services</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">3. Data Security</h2>
            <p className="text-slate-600 mb-4">
              We implement industry-standard security measures to protect your data:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>All data is encrypted in transit using TLS 1.3</li>
              <li>Sensitive credentials are encrypted at rest using AES-256</li>
              <li>Access controls and audit logging for all data access</li>
              <li>Regular security assessments and updates</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">4. Data Sharing</h2>
            <p className="text-slate-600 mb-4">
              We do not sell your personal information. We may share data with:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Delivery platforms when submitting disputes on your behalf</li>
              <li>Service providers who assist in operating our platform</li>
              <li>Law enforcement when required by law</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">5. Data Retention</h2>
            <p className="text-slate-600 mb-4">
              We retain your data for as long as your account is active or as needed to provide services.
              You may request deletion of your data at any time by contacting support@recoverrefunds.com.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">6. Your Rights</h2>
            <p className="text-slate-600 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Access and export your data</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your data</li>
              <li>Opt out of marketing communications</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">7. Contact Us</h2>
            <p className="text-slate-600 mb-4">
              For privacy-related questions, contact us at:
              <br />
              <a href="mailto:privacy@recoverrefunds.com" className="text-amber-600 hover:text-amber-700">
                privacy@recoverrefunds.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
